export default "__VITE_ASSET__DCsDx0iq__"